module.exports = __webpack_public_path__ + "img/sq_broken.b0890fe6.png";